import { useState } from "react"
import dynamic from "next/dynamic"
import SearchHeader from "@/components/SearchHeader"
import SearchProductList from "@/components/SearchResult/SearchProductList"

const Loader = dynamic(() => import("@/components/loader"))

const tabs = [
  { label: "PRODUCTS", count: 0, type: "products" },
  { label: "SPEC", count: 0, type: "spec" },
  { label: "ARTICLES AND VIDEOS", count: 0, type: "articles" },
]

const SearchResult = ({
  locale = "en",
  params = {},
  search = "",
  plpData = {},
}) => {
  const defaultLocale = locale === "default" ? "en" : locale
  const [activeTab, setActiveTab] = useState("PRODUCTS")
  const [totalProductCount, setTotalProductCount] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [tabState, setTabState] = useState(tabs)

  return (
    <>
      <SearchHeader
        tabs={tabState}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        search={search}
        totalProductCount={totalProductCount}
        defaultLocale={defaultLocale}
      />
      {isLoading && <Loader loading={isLoading} />}

      <SearchProductList
        locale={locale}
        params={params}
        search={search}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        totalProductCount={totalProductCount}
        setTotalProductCount={setTotalProductCount}
        activeTab={activeTab}
        tabState={tabState}
        setTabState={setTabState}
        setActiveTab={setActiveTab}
        plpData={plpData}
      />
    </>
  )
}

export default SearchResult
